export default (svg) => {
    const encodedSvg = window.encodeURIComponent(svg.replace(/\n/g, ''))
    return `data:image/svg+xml;utf8,${encodedSvg}`
}
